export enum Broadfield {
  AgSciences = 1,
  BioSciences = 2,
  Business = 3,
  Education = 4,
  Engineering = 5,
  FamilyConsumerHumanSciences = 6,
  HeathSciences = 7,
  Humanities = 8,
  Conservation = 9,
  PhysicalSciences = 10,
  SocialSciences = 11,
}

export const BroadfieldNameMap: Map<number, string> = new Map([
  [Broadfield.AgSciences, 'Agricultural Sciences'],
  [Broadfield.BioSciences, 'Biological and Biomedical Sciences'],
  [Broadfield.Business, 'Business'],
  [Broadfield.Education, 'Education'],
  [Broadfield.Engineering, 'Engineering'],
  [
    Broadfield.FamilyConsumerHumanSciences,
    'Family, Consumer and Human Sciences',
  ],
  [Broadfield.HeathSciences, 'Health Professions Sciences'],
  [Broadfield.Humanities, 'Humanities'],
  [Broadfield.Conservation, 'Natural Resources and Conservation'],
  [Broadfield.PhysicalSciences, 'Physical and Mathematical Sciences'],
  [Broadfield.SocialSciences, 'Social and Behavioral Sciences'],
]);
